import Vue from 'vue'
import Router from 'vue-router'
import Product from '@/components/product'
import login from '@/components/login'
import Banner from '@/components/banner'
import System from '@/components/system'
import ConponPage from '@/components/ConponPage'
import MessageTip from '@/components/MessageTip'
import ConponCharge from '@/components/ConponCharge'
import StayWord from '@/components/StayWord'
import PlayCard from '@/components/PlayCard'
import ClassifyPage from '@/components/ClassifyPage'
import QuesPage from '@/components/QuesPage'
import Notice from '@/components/Notice'
import Dynamic from "../components/Dynamic"
import Topic from "../components/Topic"
import TopicCategory from "../components/TopicCategory";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/Product',
      name: 'Product',
      component: Product
    },
    {
      path: '/Banner',
      name: 'Banner',
      component: Banner
    },
    {
      path: '/System',
      name: 'System',
      component: System
    },
    {
      path: '/conponPage',
      name: 'ConponPage',
      component: ConponPage
    },
    {
      path: '/tip',
      name: 'MessageTip',
      component: MessageTip
    },{
    	path: '/manage',
      name: 'manage',
      component: ConponCharge
    },
    {
    	path: '/stayWord',
      name: 'StayWord',
      component: StayWord
    },
    {
    	path: '/playCard',
      name: 'PlayCard',
      component: PlayCard
    },
    {
    	path: '/classifyPage',
      name: 'ClassifyPage',
      component: ClassifyPage
    },
    {
    	path: '/QuesPage',
      name: 'QuesPage',
      component: QuesPage
    },
    {
      path : '/Notice',
      name : 'Notice',
      component : Notice
    },
    {
      path : '/Dynamic',
      name : 'Dynamic',
      component : Dynamic
    },
    {
      path : '/Topic',
      name : 'Topic',
      component : Topic
    },
    {
      path : '/TopicCategory',
      name : 'TopicCategory',
      component : TopicCategory
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js